import * as React from "react";

import type { IconProps } from "./types";

const clipId = "help-icon-clip";

export const HelpIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <g clipPath={`url(#${clipId})`}>
        <circle cx="9" cy="9" r="8.5" fill="none" stroke={color} />
        <path
          d="M8.73898 10.0528C8.73898 9.7796 8.78698 9.53591 8.88298 9.32176C8.97898 9.1076 9.08975 8.92299 9.21529 8.76791C9.34821 8.61283 9.52913 8.42453 9.75806 8.20299C10.0461 7.92976 10.2565 7.69714 10.3894 7.50514C10.5297 7.30576 10.5999 7.07683 10.5999 6.81837C10.5999 6.44914 10.4965 6.16483 10.2897 5.96545C10.083 5.75868 9.77283 5.6553 9.35929 5.6553C8.56175 5.6553 8.01529 6.07991 7.7199 6.92914L6.92236 6.54145C7.10698 6.00976 7.41713 5.59622 7.85282 5.30083C8.2959 4.99806 8.80913 4.84668 9.39252 4.84668C10.0719 4.84668 10.6036 5.02391 10.9876 5.37837C11.379 5.73283 11.5747 6.21283 11.5747 6.81837C11.5747 7.17283 11.4934 7.47191 11.331 7.7156C11.1685 7.95191 10.9248 8.21776 10.5999 8.51314C10.2971 8.79376 10.0682 9.04483 9.91313 9.26637C9.76544 9.48053 9.69159 9.74268 9.69159 10.0528V10.5291H8.73898V10.0528ZM9.23744 12.7113C9.03806 12.7113 8.87559 12.6522 8.75006 12.5341C8.62452 12.4085 8.56175 12.2498 8.56175 12.0578C8.56175 11.8658 8.62452 11.707 8.75006 11.5814C8.87559 11.4559 9.03806 11.3931 9.23744 11.3931C9.42944 11.3931 9.58821 11.4559 9.71375 11.5814C9.84667 11.707 9.91313 11.8658 9.91313 12.0578C9.91313 12.2424 9.84667 12.3974 9.71375 12.523C9.58821 12.6485 9.42944 12.7113 9.23744 12.7113Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
);

HelpIcon.displayName = "HelpIcon";

export default HelpIcon;
